// src/utils/offlineData.js

import { openDB } from "idb";

// Initialize IndexedDB database
export const initDB = async () => {
  const db = await openDB("erpOfflineDB", 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains("offlineData")) {
        db.createObjectStore("offlineData", {
          keyPath: "id",
          autoIncrement: true,
        });
      }
    },
  });
  return db;
};

// Store offline data with module and action (add, update, delete)
export const storeDataOffline = async (data, moduleName, action) => {
  const db = await initDB();
  const dataWithMeta = data.map((item) => ({
    ...item,
    module: moduleName, // Store the module name (e.g., products, customers)
    action, // Store the action type (add, update, delete)
  }));

  const tx = db.transaction("offlineData", "readwrite");
  const store = tx.store;

  // Ensure that each item gets stored
  for (const item of dataWithMeta) {
    try {
      await store.put(item);
    } catch (error) {
      console.error("Error storing data:", error);
    }
  }

  await tx.done; // Commit the transaction
};

// Get all offline data
export const getOfflineData = async () => {
  const db = await initDB();
  return await db.getAll("offlineData");
};

// Clear all offline data after successful sync
export const clearOfflineData = async () => {
  const db = await initDB();
  const tx = db.transaction("offlineData", "readwrite");
  const store = tx.store;

  // Clear all stored data
  await store.clear();
  await tx.done;
};
